"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const loader_1 = require("../error/loader");
/**
 * Loads templates from other loaders.
 *
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingLoaderChain {
    /**
     * @param {Array<TwingLoaderInterface>} loaders
     */
    constructor(loaders = []) {
        this.hasSourceCache = new Map();
        this.loaders = [];
        this.TwingLoaderInterfaceImpl = this;
        for (let loader of loaders) {
            this.addLoader(loader);
        }
    }
    addLoader(loader) {
        this.loaders.push(loader);
        this.hasSourceCache = new Map();
    }
    /**
     * @return TwingLoaderInterface[]
     */
    getLoaders() {
        return this.loaders;
    }
    getSourceContext(name, from) {
        let exceptions = [];
        for (let loader of this.loaders) {
            if (!loader.exists(name, from)) {
                continue;
            }
            try {
                return loader.getSourceContext(name, from);
            }
            catch (e) {
                if (e instanceof loader_1.TwingErrorLoader) {
                    exceptions.push(e.message);
                }
            }
        }
        throw new loader_1.TwingErrorLoader(`Template "${name}" is not defined${exceptions.length ? ' (' + exceptions.join(', ') + ')' : ''}.`);
    }
    exists(name, from) {
        if (this.hasSourceCache.has(name)) {
            return this.hasSourceCache.get(name);
        }
        for (let loader of this.loaders) {
            if (loader.exists(name, from)) {
                this.hasSourceCache.set(name, true);
                return true;
            }
        }
        this.hasSourceCache.set(name, false);
        return false;
    }
    getCacheKey(name, from) {
        let exceptions = [];
        for (let loader of this.loaders) {
            if (!loader.exists(name, from)) {
                continue;
            }
            try {
                return loader.getCacheKey(name, from);
            }
            catch (e) {
                if (e instanceof loader_1.TwingErrorLoader) {
                    exceptions.push(loader.constructor.name + ': ' + e.message);
                }
            }
        }
        throw new loader_1.TwingErrorLoader(`Template "${name}" is not defined${exceptions.length ? ' (' + exceptions.join(', ') + ')' : ''}.`);
    }
    isFresh(name, time, from) {
        let exceptions = [];
        for (let loader of this.loaders) {
            if (!loader.exists(name, from)) {
                continue;
            }
            try {
                return loader.isFresh(name, time, from);
            }
            catch (e) {
                if (e instanceof loader_1.TwingErrorLoader) {
                    exceptions.push(loader.constructor.name + ': ' + e.message);
                }
            }
        }
        throw new loader_1.TwingErrorLoader(`Template "${name}" is not defined${exceptions.length ? ' (' + exceptions.join(', ') + ')' : ''}.`);
    }
    resolve(name, from) {
        let exceptions = [];
        for (let loader of this.loaders) {
            if (!loader.exists(name, from)) {
                continue;
            }
            try {
                return loader.resolve(name, from);
            }
            catch (e) {
                if (e instanceof loader_1.TwingErrorLoader) {
                    exceptions.push(loader.constructor.name + ': ' + e.message);
                }
            }
        }
        throw new loader_1.TwingErrorLoader(`Template "${name}" is not defined${exceptions.length ? ' (' + exceptions.join(', ') + ')' : ''}.`);
    }
}
exports.TwingLoaderChain = TwingLoaderChain;
